export const SET_LISTA_NEGOCIADORES_USUARIO = 'USUARIOS/SET_LISTA_NEGOCIADORES_USUARIO'
export const SET_LISTA_PERMISSOES_USUARIO = 'USUARIOS/SET_LISTA_PERMISSOES_USUARIO'
export const SET_DADOS_FORMULARIO_USUARIO = 'USUARIOS/SET_DADOS_FORMULARIO_USUARIO'
export const SET_DADOS_RETORNO_USUARIO = 'USUARIOS/SET_DADOS_RETORNO_USUARIO'
export const SET_FLAGS_DE_CONTROLE = 'USUARIOS/SET_FLAGS_DE_CONTROLE'
export const SET_POSSUI_NEGOCIADOR = 'USUARIOS/SET_POSSUI_NEGOCIADOR'
export const SET_LISTA_MERGE_PERMISSOES_USUARIO_SISTEMA = 'USUARIOS/SET_LISTA_MERGE_PERMISSOES_USUARIO_SISTEMA'
export const SET_LISTA_UNIDADES = 'USUARIOS/SET_LISTA_UNIDADES'
export const SET_LISTA_COORDENADORES = 'USUARIOS/SET_LISTA_COORDENADORES'
export const SET_LISTA_CAPAS = 'USUARIOS/SET_LISTA_CAPAS'
export const SET_LISTA_TIPOS_ACAO = 'USUARIOS/SET_LISTA_TIPOS_ACAO'
export const SET_DADOS_PERFIL_USUARIO = 'USUARIOS/SET_DADOS_PERFIL_USUARIO'
export const SET_LISTA_ESTADOS = 'USUARIOS/SET_LISTA_ESTADOS'
export const SET_DADOS_SALVOS_PERFIL_ADVOGADO = 'USUARIOS/SET_DADOS_SALVOS_PERFIL_ADVOGADO'
export const SET_DADOS_RETORNO_CADASTRO = 'USUARIOS/SET_DADOS_RETORNO_CADASTRO'
